export default "__VITE_ASSET__KIVEr0CO__"